var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "UploadFailed",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","className":"dibsvg-svg dibsvg-upload-failed","viewBox":"0 0 250 250"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <path d="M124.5 249.3c-68.8 0-124.8-56-124.8-124.8S55.7-.3 124.5-.3s124.8 56 124.8 124.8-56 124.8-124.8 124.8zm0-239.6C61.2 9.7 9.7 61.2 9.7 124.5s51.5 114.8 114.8 114.8 114.8-51.5 114.8-114.8S187.8 9.7 124.5 9.7z"/>
  <path d="M125.1 197.2c-6.2 0-11.1-4.9-11.1-11.1 0-6.2 4.9-11.3 11.1-11.3s11.3 5.1 11.3 11.3c.1 6.2-5 11.1-11.3 11.1zm1.6-41.7h-3.1c-1.4-34-8.4-77.7-8.4-84.7 0-6.2 4.1-11.9 10.1-11.9 6.1 0 10.1 5.7 10.1 11.9.1 6.8-6.6 50.3-8.7 84.7z"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/upload-failed.svg